export default __webpack_public_path__ + "static/media/renCourseImg.f0531f43.svg";